
module.exports = {
	title: 'Filter menu',
	context: {
		title: 'Våra verksamhetsområden',
		toggle: 'Visar:',
		selectedItem: 'Alla',
		items: [
			'Alla',
			'Lorem ipsum',
			'Sit amet',
			'Dolor',
			'Consectetur',
			'Lorem'
		]
	}
};
